import TextProps from "../../types/interfaces/props/TextProps";

export default function TableHeader(props: TextProps) {
    return <th scope="col" className="text-sm font-medium text-gray-900 px-6 py-4 text-center">
        {props.text}
    </th>
}